import { render, staticRenderFns } from "./ChildSupport.vue?vue&type=template&id=0c8a8f84"
import script from "./ChildSupport.vue?vue&type=script&lang=ts"
export * from "./ChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports